// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_q1-5";
export var filledCircle = "_q1-4";
export var historyEntry = "_q1-3";
export var messageSideLeft = "_q1-1";
export var messageSideRight = "_q1-2";
export var orderTrackingCarouselWrapper = "_q1-6";
export var orderTrackingInfoContainer = "_q1-0";